import { memo } from "react";

import { Text } from "@/components/atoms/Text";
import { Stack } from "@/components/atoms/Stack";
import type { TextVariant } from "@/components/atoms/types";
import { ifWeb } from "@/utils/platform";

/**
 * List Empty View
 *
 * Renders empty state messaging when no roster players match the current
 * filter criteria. Guides users to verify their organization's league and
 * team associations to ensure players are properly loaded.
 * @module features/roster-management/components/ListEmpty/ListEmptyView
 */
const ListEmptyView = () => (
  <Stack className="h-4/5 items-center justify-center gap-3">
    <Text
      variant={ifWeb<TextVariant>("title-lg", "display-sm")}
      className="text-center"
    >
      No Players
    </Text>
    <Text
      variant="unstyled"
      className={`text-center font-medium ${ifWeb("text-body", "text-title-sm")} text-content-muted`}
    >
      Make sure you have associated your organization with the correct leagues
      and teams.
    </Text>
  </Stack>
);

ListEmptyView.displayName = "ListEmptyView";

export default memo(ListEmptyView);
